export default "__VITE_ASSET__BzY7yWQV__"